// src/composables/useLoading.js
import { ref } from "vue";

const isLoading = ref(false);

export function useLoading() {
  const startLoading = () => {
    isLoading.value = true;
  };
  const stopLoading = () => {
    isLoading.value = false;
  };

  return { isLoading, startLoading, stopLoading };
}
